import React from 'react';
import {Row, Col, Breadcrumb, Button} from 'react-bootstrap';

import Cluster from '../Cluster/Cluster';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';

import './Overview.css';

import happy from '../../assets/Happy_Smiley.png';
import sad from '../../assets/Sad_Smiley.png';
import neutral from '../../assets/Neutral_Smiley.png';

const overview = (props) => {
    
    const renderUi = (name, npsScore, key, metric) => {
        if (!isNaN(npsScore)){
            if (npsScore < 0){
                if (metric === null){
                    return (
                        <div key={key} className='OverviewPanel'>
                            <span className='OverviewHeading'>{name}</span>
                            <img src={sad} alt='Sad' className='OverviewImage' onClick={props.onClicked} id={key}/>
                            <span className='OverviewLabel' style={{border:'1px solid red'}}>
                                NPS SCORE: {npsScore.toFixed(0)}
                            </span>
                        </div>
                    );
                }
                else{
                    return (
                        <div key={key} className='OverviewPanelBubble'>
                            <span className='OverviewHeading'>{name}</span>
                            <div>
                                <div className='bubble'><span>{metric}</span></div>
                                <div className='pointer'></div>
                            </div>
                            <div>
                                <div className='bubble blurred'></div>
                                <div className='pointer blurred'></div>
                            </div>
                            <img src={sad} alt='Sad' className='OverviewImageBubble' onClick={props.onClicked} id={key}/>
                            <span className='OverviewLabelBubble' style={{border:'1px solid red'}}>
                                NPS SCORE: {npsScore.toFixed(0)}
                            </span>
                        </div>
                    );
                }
            }else if (npsScore >= 50){
                if (metric === null){
                    return (
                        <div key={key} className='OverviewPanel'>
                            <span className='OverviewHeading'>{name}</span>
                            <img src={happy} alt='Happy' className='OverviewImage' onClick={props.onClicked} id={key}/>
                            <span className='OverviewLabel' style={{border:'1px solid green'}}>
                                NPS SCORE: +{npsScore.toFixed(0)}
                            </span>
                        </div>
                    );
                }
                else{
                    return (
                        <div key={key} className='OverviewPanelBubble'>
                            <span className='OverviewHeading'>{name}</span>
                            <div>
                                <div className='bubble'><span>{metric}</span></div>
                                <div className='pointer'></div>
                            </div>
                            <div>
                                <div className='bubble blurred'></div>
                                <div className='pointer blurred'></div>
                            </div>
                            <img src={happy} alt='Happy' className='OverviewImageBubble' onClick={props.onClicked} id={key}/>
                            <span className='OverviewLabelBubble' style={{border:'1px solid green'}}>
                                NPS SCORE: +{npsScore.toFixed(0)}
                            </span>
                        </div>
                    );
                }
            }else{
                if (metric === null){
                    return (
                        <div key={key} className='OverviewPanel'>
                            <span className='OverviewHeading'>{name}</span>
                            <img src={neutral} alt='Neutral' className='OverviewImage' onClick={props.onClicked} id={key}/>
                            <span className='OverviewLabel' style={{border:'1px solid yellow'}}>
                                NPS SCORE: +{npsScore.toFixed(0)}
                            </span>
                        </div>
                    );
                }
                else{
                    return (
                        <div key={key} className='OverviewPanelBubble'>
                            <span className='OverviewHeading'>{name}</span>
                            <div>
                                <div className='bubble'><span>{metric}</span></div>
                                <div className='pointer'></div>
                            </div>
                            <div>
                                <div className='bubble blurred'></div>
                                <div className='pointer blurred'></div>
                            </div>
                            <img src={neutral} alt='Neutral' className='OverviewImageBubble' onClick={props.onClicked} id={key}/>
                            <span className='OverviewLabelBubble' style={{border:'1px solid yellow'}}>
                                NPS SCORE: +{npsScore.toFixed(0)}
                            </span>
                        </div>
                    );
                }
            }
        }
        else{
            if (metric === null){
                return (
                    <div key={key} className='OverviewPanel'>
                        <span className='OverviewHeading'>{name}</span>
                        <img src={neutral} alt='Neutral' className='OverviewImage' onClick={props.onClicked} id={key}/>
                        <span className='OverviewLabel' style={{border:'1px solid yellow'}}>
                            NPS SCORE: NONE
                        </span>
                    </div>
                );
            }
            else{
                return (
                    <div key={key} className='OverviewPanelBubble'>
                        <span className='OverviewHeading'>{name}</span>
                        <div>
                            <div className='bubble'><span>{metric}</span></div>
                            <div className='pointer'></div>
                        </div>
                        <div>
                            <div className='bubble blurred'></div>
                            <div className='pointer blurred'></div>
                        </div>
                        <img src={neutral} alt='Neutral' className='OverviewImageBubble' onClick={props.onClicked} id={key}/>
                        <span className='OverviewLabelBubble' style={{border:'1px solid yellow'}}>
                            NPS SCORE: NONE
                        </span>
                    </div>
                );
            }
        }
    }

    const onBackClick = (e) => {
        props.onBackClicked();
    }

    const onShowDetailClick = (e) => {
        props.onShowDetailClicked();
    }
    
    let ui = null;
    let metrics = null;
    let buttonMetric = null;
    
    // Check if we have metric
    if (props.cluster.uiConfig != null){
        try{
            const uiConfig = JSON.parse(props.cluster.uiConfig);
            let validMetrics = true;

            if (uiConfig.buzzCSA){
                if (uiConfig.buzzCSA.buttonOrder && 
                    uiConfig.buzzCSA.buttonMetric && 
                    uiConfig.buzzCSA.metricQuestion){
                    // Next check if we have enough questions
                    for (const m of uiConfig.buzzCSA.buttonMetric) {
                        if (m >= uiConfig.buzzCSA.metricQuestion.length){
                            validMetrics = false;
                            break;
                        }
                    }
                }
                if (validMetrics){
                    metrics = uiConfig.buzzCSA.metricQuestion;
                    buttonMetric = uiConfig.buzzCSA.buttonMetric;
                }
            }
        }
        catch(err) {
            console.log('Metric error: ' + err);
        }
    }
    if (props.cluster.devices !== undefined){
        const cards = props.cluster.devices.map((device, j) => {
            let metric = null;
            
            if (metrics !== null){
                if (buttonMetric[j] < metrics.length){
                    metric = metrics[buttonMetric[j]];
                }
                else
                    metric = metrics[metrics.length - 1];       // Use last one as defualt
            } 
            if (device.stats === undefined)
                return null;
            else
                return renderUi(device.name, device.stats.npsScore, j, metric)
        });
    
        ui = (
            <div>
                <div>{cards}</div>
            </div>
        );
    }

    return (
        <Auxiliary>
            <Row>
                <Breadcrumb>
                    <Breadcrumb.Item href="#" onClick={onBackClick}>Dashboard</Breadcrumb.Item>
                    <Breadcrumb.Item active>{'Overview - ' + props.cluster.name}</Breadcrumb.Item>
                </Breadcrumb>
                <Button bsStyle='primary' onClick={onBackClick}>Go Back</Button>
            </Row>
            <Row>
                <div className="ClusterHeading">{props.cluster.name}</div>
                {/*}
                <Col xs={6}>
                    <div className='DetailPanel'>
                        <div className='DetailWeekDaily'>DAILY DISTRIBUTION - THIS WEEK</div>
                        <Bar
                            data={barDataDaily}
                            options={barOptions}
                            //onElementsClick={barEvent}
                            getElementAtEvent={(elems, event) => {onEvent(elems, event)}}
                        />
                    </div>
                </Col>
                <Col xs={6}>
                    <div className='DetailPanel'>
                        <div ref={(reference) => chartTitleReference = reference} 
                            className='DetailWeekHourly'>HOURLY DISTRIBUTION - {dayOfWeek} THIS WEEK</div>
                        <Bar
                            data={barDataHourly}
                            options={barOptions}
                            //ref={(reference) => (chartReference = reference)}
                            getChart={(chart) => {chartReference = chart}}
                        />
                    </div>
                </Col>
                {*/}
                <Cluster cluster={props.cluster} onClicked={onShowDetailClick}/>
            </Row>
            <Row>
                {/*<div className="Scroll-left">
                    <span>Click on any off the faces below for more details... </span>
                    <span>Click on any off the faces below for more details... </span>
                </div>*/}
                <Col xs={12}>
                    {ui}
                </Col>
            </Row>
        </Auxiliary>
    );
};

export default overview;